module.exports = __webpack_public_path__ + "img/create_product_from_report.edcff881.svg";